import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const emptySelectedIds = [];

const haveSameIds = (currentTags, nextTags) => {
  if (currentTags.length !== nextTags.length) return false;

  return currentTags.every((tag, index) => tag.id === nextTags[index].id);
};

export function TagsFilter({ onFiltered, selectedIds = emptySelectedIds }) {
  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadTags();
    }
    fetchData();
  }, []);

  const loadTags = async () => {
    try {
      const { data } = await api.get(`/tags/list`);
      setTags(data);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  useEffect(() => {
    if (!Array.isArray(selectedIds) || tags.length === 0) return;

    const nextSelecteds = tags.filter((tag) => selectedIds.includes(tag.id));

    setSelecteds((currentSelecteds) =>
      haveSameIds(currentSelecteds, nextSelecteds)
        ? currentSelecteds
        : nextSelecteds
    );
  }, [selectedIds, tags]);

  return (
    <Box style={{ padding: 10 }}>
      <Autocomplete
        multiple
        size="small"
        options={tags}
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={option.id}
              variant="outlined"
              style={{
                backgroundColor: option.color || "#eee",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Filtro por Tags"
          />
        )}
      />
    </Box>
  );
}
